import { extend, override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Link from 'flarum/common/components/Link';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';


export default function () {
  extend(HeaderPrimary.prototype, 'items', function (items) {
     items.add(
        `linkOfficialSite`,
        <Link href={app.translator.trans('dvdfab-header.forum.official_site_url')} target="_blank">
          <span className="LinksButton-title">{app.translator.trans('dvdfab-header.forum.official_site')}</span>
        </Link>
      );

      items.add(
        `linkDownloadCenter`,
        <Link href={app.translator.trans('dvdfab-header.forum.download_center_url')} target="_blank">
          <span className="LinksButton-title">{app.translator.trans('dvdfab-header.forum.download_center')}</span>
        </Link>
      );

    return items
  });



}
